// Simple test to check if Cloud Function is accessible
import { createLogger } from './logger';

const logger = createLogger('TestFunctionAccess');

/**
 * Test if the Cloud Function is accessible via direct HTTP call
 * This is a fallback test when httpsCallable fails
 */
export const testFunctionDirectAccess = async () => {
  try {
    const functionUrl = 'https://us-central1-pack-my-cart-dev.cloudfunctions.net/sendOrderStatusNotification';
    
    logger.info('Testing direct access to Cloud Function:', functionUrl);
    
    // This will likely fail due to CORS, but we can see the response
    const response = await fetch(functionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: {
          userId: 'test-user',
          orderId: 'test-order',
          status: 'test',
          message: 'Direct HTTP test'
        }
      })
    });
    
    if (response.ok) {
      const result = await response.json();
      logger.info('Direct HTTP test successful:', result);
      return { success: true, data: result };
    } else {
      logger.error('Direct HTTP test failed:', response.status, response.statusText);
      return { success: false, error: `HTTP ${response.status}: ${response.statusText}` };
    }
    
  } catch (error) {
    logger.error('Direct HTTP test error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Test Firebase Functions configuration
 */
export const testFirebaseFunctionsConfig = () => {
  try {
    const config = {
      projectId: process.env.REACT_APP_PROJECT_ID,
      functionsRegion: 'us-central1',
      functionName: 'sendOrderStatusNotification'
    };
    
    logger.info('Firebase Functions Config:', config);
    
    const issues = [];
    
    if (!config.projectId) {
      issues.push('Project ID not configured');
    }
    
    if (issues.length > 0) {
      return { success: false, issues, config };
    } else {
      return { success: true, config };
    }
    
  } catch (error) {
    logger.error('Firebase Functions config test error:', error);
    return { success: false, error: error.message };
  }
};






